<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="top-title-wrap">
          <div class="main-title">
            <span>{{ $t('Dashboard') }}</span>
          </div>
          <singleFilterDropdown
                class="ml-2 gray"
                v-model="selectedUsers"
                :all-button="true"
                v-if="$auth.hasRole('agency')"
                :items="agencyUsers"
                :btnText="$t('All Users')"
            />
          <div class="ml-auto">
            <DateSelect
              data-v-step="dashboard-date-picker"
              :dateStart="fromDate.format('YYYY-MM-DD')"
              :dateEnd="toDate.format('YYYY-MM-DD')"
              :errorsBag="errors"
              :autoApply="false"
              :value="rangeName"
              @open="checkComputerDateChange"
              @change="onPeriodChange($event)"
              opens="right"
            />
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <summary-statistic
          data-v-step="dashboard-header-information"
          :range="statRange"
          :users="this.agencyUsers.filter(item=>item.checked===true)"
        />
        <div class="page-sub-title">{{ $t('Campaigns') }}</div>
        <box class="chart-wrap">
          <tableTopActions>
            <dropdown
              data-v-step="dashboard-filter-campaigns"
              class="dash-drop"
              v-model="chartSelectedCampaign"
              :showSearch="true"
              :options="charCampaignsList"
              :isBusy="isCampaignsChartSearchBusy"
              @search="getDataByCampaignDebounce($event)"
            >
              <template v-slot:header="header">
                <span>{{ header.value.name }}</span>
              </template>
              <template v-slot:item="item">
                <span>{{ item.option.name }}</span>
              </template>
            </dropdown>
            <dspButtonGroup data-v-step="dashboard-by-hours">
              <dspButton v-bind:class="{ active: !chartByHours }"
                         :disabled="chartByDaysDisabled()"
                         @click="chartByHourChange(false)"
                         ref="chartByDayButton"
                         class="basic">{{ $t('by days') }}
              </dspButton>
              <dspButton v-bind:class="{ active: chartByHours }"
                         :disabled="chartByHoursDisabled()"
                         @click="chartByHourChange(true)"
                         ref="chartByHourButton"
                         class="basic">{{ $t('by hours') }}
              </dspButton>
            </dspButtonGroup>
            <div class="group ml-auto" data-v-step="dashboard-impressions">
              <dropdown class="imp-drop"
                        v-model="chartCategories[0]"
                        :showSearch="false"
                        :options="categories.filter(item => item.data !== chartCategories[1].data)">
                <template v-slot:header="header">
                  <span class="chart-control-label"></span> <span>{{ header.value.name }}</span>
                </template>
                <template v-slot:item="item">
                  <span>{{ item.option.name }}</span>
                </template>
              </dropdown>
              <dropdown class="bid-drop"
                        v-model="chartCategories[1]"
                        :showSearch="false"
                        :options="categories.filter(item => item.data !== chartCategories[0].data)">
                <template v-slot:header="header">
                  <span class="chart-control-label"></span> <span>{{ header.value.name }}</span>
                </template>
                <template v-slot:item="item">
                  <span>{{ item.option.name }}</span>
                </template>
              </dropdown>
            </div>
          </tableTopActions>
          <div v-if="isChartsBusy" class="empty-table">
            <img src="../../images/loader_smaller.svg" alt="">
          </div>
          <highcharts v-else-if="chartDotsCount>0" :options="chartOptions" ref="chart"></highcharts>
          <div v-else class="empty-table">
            <h4 class="h4">{{ $t('No data to display') }}</h4>
          </div>
        </box>
      </div>
      <div class="col-md-6 top-campaigns" data-v-step="dashboard-top-campaigns">
        <div class="page-sub-title">{{ $t('Top Campaigns') }}</div>
        <box class="alt">
          <perfect-scrollbar class="table-scroll">
            <b-table hover :fields="fields" :items="topCampaigns" :show-empty="true" :busy="isTopCampaignsBusy">
              <template slot="empty">
                <div class="empty-table">
                  <span>{{ $t('No data to display') }}</span>
                </div>
              </template>
              <template slot="table-busy">
                <div class="empty-table">
                  <img src="../../images/loader_smaller.svg" alt="">
                </div>
              </template>
              <template slot="HEAD_index">
                <span class="nobr">ID</span>
              </template>
              <template slot="index" slot-scope="data">
                <span class="nobr">{{ data.item.campaignId }}</span>
              </template>
              <template slot="name" slot-scope="data">

                                <span v-if="$auth.user().demoUser">
                                 <a href="#">
                                  {{ data.item.campaignId_dict }}
                                </a>
                                </span> <span v-else>
                                        <router-link :to="{ name: 'campaigns.edit.settings', params: { id: data.item.campaignId }  }">
                                    <span>{{ data.item.campaignId_dict }}</span>
                                </router-link>
                                </span>


              </template>
              <template slot="impressions" slot-scope="data">
                <span class="nobr">{{ data.item.impressions | integer }}</span>
              </template>
              <template slot="clicks" slot-scope="data">
                <span class="nobr">{{ data.item.clicks | integer }}</span>
              </template>
              <template slot="spend" slot-scope="data">
                <span class="nobr">$ {{ data.item.dspSpend | finance }}</span>
              </template>
            </b-table>
          </perfect-scrollbar>
        </box>
      </div>


      <div v-if="$auth.hasPermission('can-see-creative-tabs')" class="col-md-6 top-campaigns" data-v-step="dashboard-top-creatives">
        <div class="page-sub-title">{{ $t('Top Creatives') }}</div>
        <box class="alt">
          <perfect-scrollbar class="table-scroll">
            <b-table hover :fields="fields" :items="topCreatives" :show-empty="true" :busy="isTopCreativesBusy">
              <template slot="empty">
                <div class="empty-table">
                  <span>{{ $t('No data to display') }}</span>
                </div>
              </template>
              <template slot="table-busy">
                <div class="empty-table">
                  <img src="../../images/loader_smaller.svg" alt="">
                </div>
              </template>
              <template slot="HEAD_index">
                <span class="nobr">ID</span>
              </template>
              <template slot="index" slot-scope="data">
                <span class="nobr">{{ data.item.creativeId }}</span>
              </template>
              <template slot="name" slot-scope="data">

                <a v-if="$auth.user().demoUser" href="#"> {{ data.item.creativeId_dict }} </a> <a v-else
                                                                                                  @click.prevent="gotoCreative(data.item.creativeId)"
                                                                                                  href="#"> {{ data.item.creativeId_dict }} </a>


              </template>
              <template slot="impressions" slot-scope="data">
                <span class="nobr">{{ data.item.impressions }}</span>
              </template>
              <template slot="clicks" slot-scope="data">
                <span class="nobr">{{ data.item.clicks }}</span>
              </template>
              <template slot="spend" slot-scope="data">
                <span class="nobr">$ {{ data.item.dspSpend | finance }}</span>
              </template>
            </b-table>
          </perfect-scrollbar>
        </box>
      </div>


      <div class="col-md-6 top-campaigns"  v-if="$auth.hasPermission('conversion')">
        <dasboardConversions/>
      </div>
      <div class="col-md-6 top-campaigns">
        <!--                <dasboardPostbacks />-->
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { datesToPeriod } from '@/lib/periodToDates';
import GetDatesFromStore from '@/lib/getDatesFromStore';
import DateSelect from '@/components/DatePicker/DateSelect.vue';
import summaryStatistic from '@/components/shared/summaryStatistic.vue';
import dasboardConversions from './parts/conversions.vue';
import { debounce } from 'debounce';

// import dasboardPostbacks from "./parts/postbacks.vue"

export default {
  name: 'dashboard',

  mixins: [GetDatesFromStore],

  components: {
    DateSelect,
    summaryStatistic,
    dasboardConversions, // dasboardPostbacks
  },

  data: function () {
    return {
      selectedUsers: {},
      agencyUsers: [],
      currentDate: moment().format('YYYY-MM-DD'),

      charCampaignsList: [],
      campaignsFromStatList: [],
      chartAllCampaignsItem: {
        id: null,
        name: this.$t('All Campaigns'),
      },

      chartSelectedCampaign: {
        id: null,
        name: this.$t('All Campaigns'),
      },

      chartCategories: [{}, {}],
      chartCategoriesColors: ['#9C6ADE', '#59C7C5'],

      categories: [{
        name: this.$t('Bids'),
        data: 'bids',
        decimals: 0,
        suffix: '',
        prefix: '',
      }, {
        name: this.$t('Wins'),
        data: 'wins',
        decimals: 0,
        suffix: '',
        prefix: '',
      }, {
        name: this.$t('Impressions'),
        data: 'impressions',
        decimals: 0,
        suffix: '',
        prefix: '',
      }, {
        name: this.$t('Clicks'),
        data: 'clicks',
        decimals: 0,
        suffix: '',
        prefix: '',
      }, {
        name: this.$t('Conversions'),
        data: 'conversions',
        decimals: 0,
        suffix: '',
        prefix: '',
      }, {
        name: this.$t('Spend'),
        data: 'dspSpend',
        decimals: 2,
        suffix: '',
        prefix: '$ ',
      },
        // {
        //     name: this.$t("eCPM"),
        //     data: "ecpm",
        //     decimals: 2,
        //     suffix: "",
        //     prefix: "$ ",
        // },
        // {
        //     name: this.$t("eCPC"),
        //     data: "ecpc",
        //     decimals: 2,
        //     suffix: "",
        //     prefix: "$",
        // },
        // {
        //     name: this.$t("eCPA"),
        //     data: "ecpa",
        //     decimals: 2,
        //     suffix: "",
        //     prefix: "$",
        // },
        // {
        //     name: this.$t("CTR"),
        //     data: "ctr",
        //     decimals: 2,
        //     suffix: "%",
        //     prefix: "",
        // },
        // {
        //     name: this.$t("WinRate"),
        //     data: "winrate",
        //     decimals: 2,
        //     suffix: "%",
        //     prefix: "",
        // },
      ],

      chartOptions: {
        title: '',
        series: [{ data: [] }],
        tooltip: {
          borderWidth: 1,
          shared: true,
          backgroundColor: '#212B36',
          borderColor: '#212B36',
          className: 'dash-tooltip',
          useHTML: true,
          headerFormat: '<div style=\'display: flex; flex-direction: column;  align-items: center; width: 175px; height: 60px\'>' + '<div style="color:#fff;font-size: 12px; margin-top: 7px; line-height: 20px; display: block; text-align: center; width: 100%">{point.key}</div><br><div style=\'display: flex; justify-items: center; align-items: center;  width: 100%\'>',
          pointFormat: '<div style=\'color:#fff;font-size:12px; width: 50%; display: flex; align-items: center\'><div style="background-color:{point.color}; margin-right: 8px; display:inline-block; width: 16px; height: 16px; border-radius: 3px; line-height: 20px "></div>' + '<b>{point.y}</b>' + '</div>',
          footerFormat: '</div></div>',

        },
        xAxis: {
          categories: [],
          labels: {
            y: 50,
            align: 'center',
            formatter: function () {
              return this.value;
            }
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        chart: {
          minPadding: 0,
          maxPadding: 0,
          marginTop: 25, // plotBorderColor: '#ff0000',
        },
      },

      chartDotsCount: 0,

      topCampaigns: [],
      topCreatives: [],
      topCreativesTmp: [],

      sortBy: 'status',
      sortDesc: false,
      fields: [{
        key: 'index',
        label: this.$t('Index'),
        sortable: false
      }, {
        key: 'name',
        label: this.$t('Name'),
        sortable: false
      }, {
        key: 'impressions',
        label: this.$t('Impressions'),
        sortable: false
      }, {
        key: 'clicks',
        label: this.$t('Clicks'),
        sortable: false
      }, {
        key: 'spend',
        label: this.$t('Spend'),
        sortable: false
      }],
      isTopCampaignsBusy: false,
      isTopCreativesBusy: false,
      isChartsBusy: false,
      isCampaignsChartSearchBusy: false,
    };
  },

  watch: {
    chartSelectedCampaign () {
      this.getChart();
      this.getTopCampaigns();
      this.getTopCreatives();
    },

    chartByHours () {
      this.getChart();
    },

    chartCategories () {
      this.getChart();
    },
    agencyUsers: {
      handler () {
        this.getChart();
        this.getTopCampaigns();
        this.getTopCreatives();
      },
      deep: true
    },

  }, // mounted () {
  //   setTimeout(() => {
  //     this.$auth.checkRole('admin');
  //
  //   },100);
  // },
  computed: {
    rangeName: {
      get () {
        return this.$store.getters['dashboard/getDateRange'].rangeName;
      },
      set (value) {
        let rangeData = this.$store.getters['dashboard/getDateRange'];
        rangeData['rangeName'] = value;
        this.$store.commit('dashboard/setDateRange', rangeData);
      }
    },

    statRange () {
      return [this.fromDate, this.toDate];
    },

    fromDate: {
      get () {
        const fromDate = this.getDateStore('dashboard/getDateRange').fromDate;

        return fromDate ? fromDate : moment();
      },
      set (value) {
        let rangeData = this.$store.getters['dashboard/getDateRange'];
        rangeData['fromDate'] = value;
        this.$store.commit('dashboard/setDateRange', rangeData);
      }
    },

    toDate: {
      get () {
        const toDate = this.getDateStore('dashboard/getDateRange').toDate;

        return toDate ? toDate : moment();
      },
      set (value) {
        let rangeData = this.$store.getters['dashboard/getDateRange'];
        rangeData['toDate'] = value;
        this.$store.commit('dashboard/setDateRange', rangeData);
      }
    },

    chartByHours: {
      get () {
        let byHours = this.$store.getters['dashboard/getDateRange'].byHours;

        if (byHours && this.chartByHoursDisabled()) {
          byHours = false;
        }

        if (!byHours && this.chartByDaysDisabled()) {
          byHours = true;
        }

        return byHours;
      },
      set (value) {
        let rangeData = this.$store.getters['dashboard/getDateRange'];
        rangeData['byHours'] = value;
        this.$store.commit('dashboard/setDateRange', rangeData);
      }
    },
  },

  created () {
    // Tawk is initialized globally in src/main.js

    this.chartCategories[0] = this.categories.find(item => item.name === this.$t('Impressions'));
    this.chartCategories[1] = this.categories.find(item => item.name === this.$t('Bids'));

    if (this.$auth.hasRole('agency')) {
      let result = [];
      this.$auth.user().agencyUsers.forEach(items => {
        result.push({
          label: items['firstName'] + ' ' + items['lastName'] + '  id# ' + items['id'],
          value: items['id'],
          checked: true
        });
      });

      this.agencyUsers = result;
      this.agencyUsers.unshift({
        label: this.$auth.user().firstName + ' ' + this.$auth.user().lastName + '  id# ' + this.$auth.user().id,
        value: this.$auth.user().id,
        checked: true
      });
    }

    this.checkCanSeeClickAccess();
    this.checkCanSeePrices();
    this.getChart();
    this.getCampaignsList();
    this.getTopCampaigns();
    this.getTopCreatives();
  },

  methods: {
    checkCanSeeClickAccess () {
      if (this.$auth.hasRole('admin') || this.$auth.user().canSeeClick) {
        return;
      }

      this.fields = this.fields.filter(item => item.key !== 'clicks');
    },

    checkCanSeePrices () {
      if (this.$auth.hasRole('admin') || !this.$auth.hasPermission('cant-see-prices')) {
        return;
      }

      this.fields = this.fields.filter(item => item.key !== 'spend' );
      this.categories = this.categories.filter(item => item.data !== 'dspSpend' );
    },

    async gotoCreative (creativeId) {
      this.$router.push({
        name: 'creatives.editAutoType',
        params: { id: creativeId }
      });
    },

    checkComputerDateChange () {
      if (this.currentDate !== moment().format('YYYY-MM-DD')) {
        this.currentDate = moment().format('YYYY-MM-DD');
        this.rangeName = this.rangeName;
      }
    },

    onPeriodChange (event) {
      this.fromDate = moment(event.dateStart);
      this.toDate = moment(event.dateEnd);
      this.rangeName = datesToPeriod(event.dateStart, event.dateEnd);

      this.chartByHours = this.fromDate.format('YYYY-MM-DD') === this.toDate.format('YYYY-MM-DD');

      this.chartSelectedCampaign = this.chartAllCampaignsItem;

      // this.getChart();
      // this.getCampaignsList();
      // this.getTopCampaigns();
      // this.getTopCreatives();
    },

    chartByDaysDisabled () {
      return this.toDate.diff(this.fromDate, 'days') === 0;
    },

    chartByHoursDisabled () {
      // Enable by hours grouping for 2 days period maximum
      return this.toDate.diff(this.fromDate, 'days') > 1;
    },

    chartByHourChange (value) {
      if (value && this.chartByHoursDisabled()) {
        this.$nextTick(() => {
          this.$refs.chartByHourButton.$el.blur();
        });
        return;
      }

      if (!value && this.chartByDaysDisabled()) {
        this.$nextTick(() => {
          this.$refs.chartByDayButton.$el.blur();
        });

        return;
      }

      this.chartByHours = value;
    },

    getChart () {
      this.chartOptions.series = [];
      this.chartOptions.xAxis.categories = [];

      let dateField = this.chartByHours ? 'YMDH' : 'YMD';
      const agregatedFields = this.chartCategories.map(item => item.data);
      let filter = {};

      if (this.$auth.hasRole('agency')) {
        filter = {
          'advertiserId': this.agencyUsers.filter(item=>item.checked===true).map(a => a['value']),
        };
      }
      let data = {
        timezone: 'UTC',
        filter:filter,
        from: this.fromDate.format('YYYY-MM-DD'),
        to: this.toDate.format('YYYY-MM-DD'),
        groupBy: [dateField],
        agregatedFields,
        orderField: dateField,
        orderDir: 'asc',
        rowsOnPage: 500,
        page: 1
      };

      if (this.chartSelectedCampaign.id) {
        data['filter'] = {
          'campaignId': this.chartSelectedCampaign.id,
        };
      }

      this.chartDotsCount = 0;
      this.isChartsBusy = true;

      this.$axios.post('/statistic', data).then(response => {
        this.isChartsBusy = false;
        let result = [];

        this.chartCategories.map((category, index) => {
          let line = response.data.data.map(item => {
            return +item[category.data];
          });

          this.chartDotsCount += line.length;

          result.push({
            name: category.name,
            color: this.chartCategoriesColors[index],
            data: line,

            lineWidth: 5,
            tooltip: {
              valueDecimals: category.decimals,
              valuePrefix: category.prefix,
              valueSuffix: category.suffix,
            },
            marker: {
              symbol: 'circle',
              fillColor: this.chartCategoriesColors[index],
              lineWidth: 3,
              radius: 6,
              lineColor: '#FFFFFF'
            }

          });
        });

        this.chartOptions.series = result;

        //let daysDiff = this.toDate.diff(this.fromDate, 'days');

        this.chartOptions.xAxis.categories = response.data.data.map(item => {
          // if (daysDiff === 0) {
          //     return item[dateField].substring(10, 16);
          // }

          if (this.chartByHours) {
            return item[dateField].substring(11, 16);
            // return item[dateField].substring(0, 16);
          }

          return item[dateField];
        });
      }).catch(() => {
        this.isChartsBusy = false;
      });
    },

    getCampaignsList (search = null) {

      let filter = {};
      if (this.$auth.hasRole('agency')) {
        filter = {
          'advertiserId': this.agencyUsers.map(a => a['value']),
        };
      }
      this.isCampaignsChartSearchBusy = true;
      this.$axios.post('/statistic', {
        timezone: 'UTC',
        from: this.fromDate.format('YYYY-MM-DD'),
        to: this.toDate.format('YYYY-MM-DD'),
        groupBy: ['campaignId'],
        agregatedFields: [],
        orderField: 'bids',
        orderDir: 'desc',
        rowsOnPage: 999,
        page: 1,
        filter: filter
      }).then(response => {
        this.isCampaignsChartSearchBusy = false;
        this.campaignsFromStatList = response.data.data.map(item => {
          return {
            id: item.campaignId,
            name: item.campaignId_dict,
          };
        });
        this.charCampaignsList = this.campaignsFromStatList.filter(item => {
          if (!search) {
            return true;
          }
          return item.id.toString().toLowerCase().includes(search.toString().toLowerCase()) || item.name.toString().toLowerCase().includes(search.toString().toLowerCase());
        }).slice(0, 10);
        this.charCampaignsList.unshift(this.chartAllCampaignsItem);
      });
    },
    getTopCampaigns () {

      this.isTopCampaignsBusy = true;
      let filter = {};
      if (this.chartSelectedCampaign.id) {
        filter.campaignId = this.chartSelectedCampaign.id;
      }
      if (this.$auth.hasRole('agency')) {
        filter = {
          'advertiserId': this.agencyUsers.filter(item=>item.checked===true).map(a => a['value']),

        };
      }
      this.$axios.post('/statistic', {
        timezone: 'UTC',
        from: this.fromDate.format('YYYY-MM-DD'),
        to: this.toDate.format('YYYY-MM-DD'),
        groupBy: ['campaignId'],
        agregatedFields: ['impressions', 'clicks', 'dspSpend'],
        orderField: 'impressions',
        orderDir: 'desc',
        rowsOnPage: 5,
        page: 1,
        filter: filter
      }).then(response => {
        this.topCampaigns = response.data.data;
        this.isTopCampaignsBusy = false;
      }).catch(() => {
        this.isTopCampaignsBusy = false;
      });
    },

    getTopCreatives () {
      this.isTopCreativesBusy = true;
      let filter = {};
      if (this.chartSelectedCampaign.id) {
        filter.campaignId = this.chartSelectedCampaign.id;
      }
      if (this.$auth.hasRole('agency')) {
        filter = {
          'advertiserId': this.agencyUsers.filter(item=>item.checked===true).map(a => a['value']),

        };
      }
      this.$axios.post('/statistic', {
        timezone: 'UTC',
        from: this.fromDate.format('YYYY-MM-DD'),
        to: this.toDate.format('YYYY-MM-DD'),
        groupBy: ['creativeId'],
        agregatedFields: ['impressions', 'clicks', 'dspSpend'],
        orderField: 'impressions',
        orderDir: 'desc',
        rowsOnPage: 5,
        page: 1,
        filter: filter
      }).then(response => {
        this.topCreatives = response.data.data;
        const topCreativeIds = this.topCreatives.map(cr => {
          return cr.creativeId;
        });
        this.$axios.get(`/creatives?search=id:${topCreativeIds.join()}&searchFields=id:in`).then(resp => {
          this.topCreativesTmp = resp.data.data;
        });
        this.isTopCreativesBusy = false;
      }).catch(() => {
        this.isTopCreativesBusy = false;
      });
    },

    getDataByCampaignDebounce: debounce(function (search) {
      this.charCampaignsList = this.campaignsFromStatList.filter(item => {
        if (!search) {
          return true;
        }
        return item.id.toString().toLowerCase().includes(search.toString().toLowerCase()) || item.name.toString().toLowerCase().includes(search.toString().toLowerCase());
      }).slice(0, 10);
      this.charCampaignsList.unshift(this.chartAllCampaignsItem);
    }, 500),
  }

};
</script>
<style>
.nobr {
  white-space: nowrap;
}
</style>
<style scoped>
.chart-wrap .empty-table {
  min-height: 250px;
}

.top-campaigns .empty-table {
  min-height: 180px;
}
</style>
